

























import Vue from 'vue';

export default Vue.extend({
	name: 'Survey',

	props: {
		baseURL: { type: String, required: true },
		token: { type: String, required: true },
	},

	data() {
		return {
			error: '',
			iframeHeight: '500px' as number | string,
		};
	},

	computed: {
		cssPath(): string {
			return this.paths.css || '';
		},
		iframeURL(): string {
			return this.cssPath
				? `${this.baseURL}?stylesheet=${this.cssPath}`
				: this.baseURL;
		},
		paths(): App.Paths {
			return this.$store.state.paths;
		},
	},

	created() {
		if (!this.token) {
			window.location.replace(this.paths.home);
		}

		window.addEventListener('message', (event) => {
			if (!event.data) {
				return;
			}

			if (event.data.size) {
				this.resizeFrame(event.data.size);
			}

			if (event.data.error) {
				this.error = event.data.error;
			}
		});
	},

	methods: {
		resizeFrame(size: number | string) {
			this.iframeHeight = `${size}px`;
		},
	},
});
